import { c as _c } from "react/compiler-runtime";
import useSWR from 'swr';
export interface MetaDataFromServerInterface {
  hostOnServer: string | null;
}
export const META_DATA_FROM_SERVER_KEY = 'meta-data-from-server';
export const useMetadataFromServer = () => {
  const $ = _c(2);
  const {
    data
  } = useSWR(META_DATA_FROM_SERVER_KEY);
  let t0;
  if ($[0] !== data) {
    t0 = {
      data
    };
    $[0] = data;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};